import React, { Fragment, useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import AuthContext from "../../context/auth/AuthContext";
import AlertContext from "../../context/alert/AlertContext";
import ConfigContext from "../../context/config/ConfigContext";
import CardContext from "../../context/card/CardContext";
import NavigationContext from "../../context/navigation/NavigationContext";
import Preloader from "./../layout/Preloader";
import ActionMenu from "./../layout/ActionMenu";
import DataTable from "../common/DataTable";
import SearchMenu from "../common/SearchMenu";
// import { Orders } from "./../common/Orders";
// import Moment from "react-moment";
import moment from "moment";
// import "moment-timezone";
import useTokenCheck from "../../hooks/useTokenCheck";
import usePageTitle from "../../hooks/usePageTitle";
import { env } from "../../env";

const OrderHistory = (props) => {
  const authContext = useContext(AuthContext);
  const { token } = authContext;
  const configContext = useContext(ConfigContext);
  const { loaded, getConfigValue, getConfigValueByCode } = configContext;
  const alertContext = useContext(AlertContext);
  const { setAlert, clearAlerts } = alertContext;
  const cardContext = useContext(CardContext);
  const navigationContext = useContext(NavigationContext);
  const { orders, loadOrders, orderLoading, getOrderDetails, resetCardState } =
    cardContext;
  const { navigationBack, resetNavigationState } = navigationContext;
  // const [searchCriteria, setSearchCriteria] = useState({
  //   filterType: "",
  //   filterValue: "",
  // });
  const history = useHistory();
  const [pageSize, setPageSize] = useState(25);

  usePageTitle({
    appTitle: props.appTitle,
    pageTitle: "Order History",
  });

  useEffect(() => {
    console.log("checking navigation", navigationBack);
    if (navigationBack) {
      resetNavigationState();
    } else {
      console.log("RESETing");
      resetCardState();
    }
    if (loaded) {
      const pageSize = getConfigValue(
        "generalConfig",
        "page_size",
        "App_Config"
      );
      console.log("SETing pageSize ", pageSize);
      setPageSize(pageSize);
    }
    //eslint-disable-next-line
  }, []);

  // useEffect(() => {
  //   if (orderLoaded) {
  //     console.log("Search Completed::::", orders);
  //   }
  //   //eslint-disable-next-line
  // }, [orderLoaded, orders]);
  const { hasTokenExpired } = useTokenCheck();
  //setCurrentCard
  const selectCurrentOrder = async (orderId) => {
    await hasTokenExpired();
    console.log("Setting Order Details::::", orderId);
    try {
      const res = await getOrderDetails(orderId, token);
      console.log("Order Detail Res:", res);
      history.push("/order-detail");
    } catch (err) {
      clearAlerts();
      const msg = getConfigValueByCode("patronConfig", "RESPONSE_MSG", 475);
      setAlert(msg, "danger");
    }
  };

  const getFormattedObject = (orders) => {
    if (!orders) return [];
    return orders.map((order) => {
      return {
        ...order,
        creationDate: moment
          .utc(order.creationDate)
          .tz(env.REACT_APP_HMW_TIME_ZONE)
          .format("MM/DD/YYYY hh:mm A"),
        price: `$ ${(order.price / 100).toFixed(2)}`,
      };
    });
  };

  const searchOrders = async (criteria) => {
    await hasTokenExpired();
    clearAlerts();
    setTableAlert(" ");
    console.log("###Criteria: ", criteria);
    const { filterType, filterValue, fromPeriod, toPeriod } = criteria;
    let searchCriteria = {};
    // searchCriteria = {
    //   filterType: filterType === "" ? "all" : filterType,
    // };
    // if (filterType !== "") {
    searchCriteria = {
      filterType,
    };
    if (filterValue !== "") {
      searchCriteria = {
        ...searchCriteria,
        filterValue,
      };
      // }
      // else {
      //   searchCriteria = {
      //     ...searchCriteria,
      //     filterValue: filterType,
      //   };
      // }
    }

    // setSearchCriteria({
    //   ...criteria,
    // });
    // searchCriteria = {
    //   filterType,
    //   filterValue,
    // };
    console.log("FROM", criteria.fromPeriod, criteria.toPeriod, searchCriteria);
    if (
      (criteria.fromPeriod || criteria.toPeriod) &&
      (!criteria.fromPeriod || !criteria.toPeriod)
    ) {
      clearAlerts();
      const msg = getConfigValueByCode("patronConfig", "RESPONSE_MSG", 466);
      setAlert(msg, "warning");
    } else {
      if (criteria.fromPeriod > criteria.toPeriod) {
        clearAlerts();
        const msg = getConfigValueByCode("patronConfig", "RESPONSE_MSG", 467);
        setAlert(msg, "warning");
        return;
      } else if (criteria.fromPeriod !== criteria.toPeriod) {
        searchCriteria = {
          ...searchCriteria,
          fromDate: moment(fromPeriod).format("DD-MM-YYYY"),
          toDate: moment(toPeriod).format("DD-MM-YYYY"),
        };
      }
      try {
        console.log("$$Criteria: ", searchCriteria);
        const res = await loadOrders(searchCriteria, token);
        console.log("$$RES: ", res);
        if (res && res.msgCode) {
          const msg = getConfigValueByCode(
            "generalConfig",
            "RESPONSE_MSG",
            res.msgCode
          );
          clearAlerts();
          setAlert(msg, "warning");
        } else {
          setTableAlert(
            "Search is successfully completed and matching records are displayed in the table"
          );
        }
        // if (res.length === 0) {
        //   clearAlerts();
        //   setAlert("No matching records found", "warning");
        // }
      } catch (err) {
        console.log("$ERR:", err);
        // const msg = getConfigValueByCode(
        //   "generalConfig",
        //   "RESPONSE_MSG",
        //   500
        // );
        // if (err.msgCode) {
        //   const msg = getConfigValueByCode(
        //     "generalConfig",
        //     "RESPONSE_MSG",
        //     err.msgCode
        //   );
        //   clearAlerts();
        //   setAlert(msg, "warning");
        // }

        clearAlerts();
        const msg = getConfigValueByCode("patronConfig", "RESPONSE_MSG", 475);
        setAlert(msg, "danger");
      }
    }
  };
  const searchByList = [
    {
      name: "OrderNumber",
      displayName: "Order Number",
      requireInput: true,
    },
    {
      name: "Cancelled",
      displayName: "Cancelled",
      requireInput: false,
    },
    {
      name: "Honoured",
      displayName: "Honoured",
      requireInput: false,
    },
    {
      name: "ProcessingOrder",
      displayName: "Processing Order",
      requireInput: false,
    },
    {
      name: "Rejected",
      displayName: "Rejected",
      requireInput: false,
    },
  ];

  const columnDefs = [
    {
      Header: "Order Number",
      accessor: "id",
      className: "drillColumn",
      customCell: "action",
      onClickAction: (rowIndex, columnId, value) => {
        // We also turn on the flag to not reset the page
        selectCurrentOrder(value);
      }, // This is a custom function that we supplied to our table instance
      fieldType: "link",
    },
    {
      Header: "Order Amount",
      accessor: "price",
      clickable: false,
    },
    {
      Header: "Order Status",
      accessor: "status",
      clickable: false,
      filter: "text",
    },
    {
      Header: "Order Date",
      accessor: "creationDate",
      clickable: false,
    },
  ];

  const [tableAlert, setTableAlert] = useState(" ");
  console.log("setTableAlert", tableAlert);

  return (
    <Fragment>
      {orderLoading && <Preloader />}
      <ActionMenu resetUseIdleTimer={props.resetUseIdleTimer} />
      <div
        className="patronPage"
        role="main"
        ref={props.mainContentRef}
        tabIndex="-1"
      >
        <h1 id="pageHeader" className="patronPage__pageTitle">
          ORDER HISTORY
        </h1>
        <div className="patronPage__content">
          <div className="patronPage__searchBar">
            <SearchMenu
              onSearch={searchOrders}
              searchByList={searchByList}
              includePeriod={true}
            />
          </div>
          <div
            aria-live="polite"
            style={{ color: "transparent", height: "1px" }}
          >
            {tableAlert}
          </div>
          {orders && orders.length > 0 && (
            <div className="patronPage__tableListing">
              {/* <TableListing data={getFormattedObject(orders)} /> */}
              <DataTable
                data={getFormattedObject(orders)}
                columnDefs={columnDefs}
                pageSize={pageSize}
              />
            </div>
          )}
        </div>
      </div>
    </Fragment>
  );
};

export default OrderHistory;
